const searchTerms: string[] = [
	'emControl',
	'Rhythm',
	'Android',
	'iOS',
	'Envoy',
	'Encore',
	'EcoFlex',
	'PulseTech',
	'Mobius',
	'Drivers',
	'R6',
	'R7',
	'Manual',
	'Guide',
	'Data',
	'Sheet',
	'Data sheet',
	'Certification',
	'Battery',
	'SydeKick',
	'Charger',
	'Update',
	'Windows',
]

export {
	searchTerms
}